var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uploading-progress-bar-container" }, [
    _c("div", { staticClass: "d-flex align-items-center gap-10px" }, [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "16",
            viewBox: "0 0 20 16",
            fill: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M13.3333 8.33335C13.3333 8.23613 13.3021 8.15627 13.2396 8.09377L9.57292 4.4271C9.51042 4.3646 9.43056 4.33335 9.33333 4.33335C9.23611 4.33335 9.15625 4.3646 9.09375 4.4271L5.4375 8.08335C5.36806 8.16669 5.33333 8.25002 5.33333 8.33335C5.33333 8.43058 5.36458 8.51044 5.42708 8.57294C5.48958 8.63544 5.56944 8.66669 5.66667 8.66669H8V12.3334C8 12.4236 8.03299 12.5018 8.09896 12.5677C8.16493 12.6337 8.24306 12.6667 8.33333 12.6667H10.3333C10.4236 12.6667 10.5017 12.6337 10.5677 12.5677C10.6337 12.5018 10.6667 12.4236 10.6667 12.3334V8.66669H13C13.0903 8.66669 13.1684 8.6337 13.2344 8.56773C13.3003 8.50176 13.3333 8.42363 13.3333 8.33335ZM20 11.3334C20 12.4375 19.6094 13.3802 18.8281 14.1615C18.0469 14.9427 17.1042 15.3334 16 15.3334H4.66667C3.38194 15.3334 2.28299 14.8768 1.36979 13.9636C0.456597 13.0504 0 11.9514 0 10.6667C0 9.76391 0.243056 8.93058 0.729167 8.16669C1.21528 7.4028 1.86806 6.82988 2.6875 6.44794C2.67361 6.2396 2.66667 6.0903 2.66667 6.00002C2.66667 4.5278 3.1875 3.27085 4.22917 2.22919C5.27083 1.18752 6.52778 0.666687 8 0.666687C9.08333 0.666687 10.0747 0.96877 10.974 1.57294C11.8733 2.1771 12.5278 2.97919 12.9375 3.97919C13.4306 3.54863 14.0069 3.33335 14.6667 3.33335C15.4028 3.33335 16.0312 3.59377 16.5521 4.1146C17.0729 4.63544 17.3333 5.26391 17.3333 6.00002C17.3333 6.5278 17.191 7.00697 16.9062 7.43752C17.809 7.6528 18.5503 8.12328 19.1302 8.84898C19.7101 9.57467 20 10.4028 20 11.3334Z",
              fill: "#2D5089",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("strong", { domProps: { innerHTML: _vm._s(_vm.renderText) } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "uploading-progress-bar" }, [
      _c("div", { staticClass: "progress" }, [
        _c("div", {
          staticClass:
            "progress-bar progress-bar-striped progress-bar-animated",
          style: { width: _vm.progressPercentage + "%" },
          attrs: {
            role: "progressbar",
            "aria-valuenow": "50",
            "aria-valuemin": "0",
            "aria-valuemax": "100",
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "12",
              height: "14",
              viewBox: "0 0 12 14",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M7.33332 0.333344H1.99999C1.26666 0.333344 0.673323 0.933344 0.673323 1.66668L0.666656 12.3333C0.666656 13.0667 1.25999 13.6667 1.99332 13.6667H9.99999C10.7333 13.6667 11.3333 13.0667 11.3333 12.3333V4.33334L7.33332 0.333344ZM1.99999 12.3333V1.66668H6.66666V5.00001H9.99999V12.3333H1.99999Z",
                fill: "#2D5089",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("strong", [
        _vm._v(
          _vm._s(_vm.uploadedFilesLength()) +
            " / " +
            _vm._s(_vm.selectedFilesLength())
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }